'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$40() {
  this.azy = null;
  this.azw = null;
  this.azx = false;
  this.azu = null;
  this.azv = false;
  this.azz = false;
  this.azA = false;
  this.azy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$40 as $c_Lpresto_AgentView$$anon$40 };
$p = $c_Lpresto_AgentView$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$40;
/** @constructor */
function $h_Lpresto_AgentView$$anon$40() {
}
export { $h_Lpresto_AgentView$$anon$40 as $h_Lpresto_AgentView$$anon$40 };
$h_Lpresto_AgentView$$anon$40.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.azy;
});
$p.t = (function() {
  if ((!this.azx)) {
    this.azw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azx = true;
  }
  return this.azw;
});
$p.ae = (function() {
  if ((!this.azv)) {
    this.azu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2H(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nN(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.azv = true;
  }
  return this.azu;
});
$p.w = (function() {
  if ((!this.azA)) {
    this.azz = false;
    this.azA = true;
  }
  return this.azz;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$40, "presto.AgentView$$anon$40", ({
  E6: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$40 as $d_Lpresto_AgentView$$anon$40 };
//# sourceMappingURL=presto.-Agent-View$$anon$40.js.map
